export default __webpack_public_path__ + "static/media/cr.b9e32234.svg";